
<template>
  <div class="mailbox-settings-auto-forwarding-email">
    <i class="ddi ddi-auto-forwarding" />
    <span class="mailbox-settings-auto-forwarding-email__title">{{ email }}</span>
    <div>
      <dd-icon-button 
        danger
        icon="trash"
        type="rounded"
        size="medium"
        color="grey"
        @click="remove" 
      />
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MailboxSettingsAutoForwardingEmail',

  props: {
    email: {
      type: String,
      required: true,
    },
  },

  emits: ['remove'],
  methods: {
    remove(): void {
      this.$emit('remove', this.email)
    },
  },
})
</script>

<style lang="scss" scoped>
.mailbox-settings-auto-forwarding-email {
  display: flex;
  align-items: center;
  padding: 12px 0;

  &:not(:last-child) {
    border-bottom: $border--solid-extra-light;
  }

  > i {
    color: var(--color-text-third);
  }

  &__title {
    margin-left: 10px;
    @include lettering--p;
    font-weight: $bold;
  }

  > div {
    display: flex;
    margin-left: auto;

    > :last-child {
      margin-left: 8px;
    }
  }
}
</style>
